import React, { Component } from 'react'
import CheckPermissions from './CheckPermissions'

class Authorized extends Component {
  render () {
    const {children, authority, noMatch = null} = this.props
    const childrenRender = typeof children === 'undefined' ? null : children
    return CheckPermissions(authority, childrenRender, noMatch)
  }
}

export default Authorized



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/components/Authorized/Authorized.js